import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgTickWhy({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path d="M8 11.5A2.25 2.25 0 118 16a2.25 2.25 0 010-4.5zM8.1 0c.58 0 1.16.11 1.75.33.59.23 1.11.53 1.58.9.48.38.86.84 1.16 1.39a3.52 3.52 0 01.27 2.8 3.6 3.6 0 01-.38.84c-.14.22-.34.43-.6.65a5.76 5.76 0 01-1.28.85c-.3.17-.55.4-.74.7-.2.31-.3 1-.3 1.19 0 .12-.05.24-.13.35-.09.11-.2.17-.3.17H6.51c-.11 0-.2-.07-.28-.2a.83.83 0 01-.11-.4v-.94c0-.6.23-1.17.7-1.7A4.6 4.6 0 018.4 5.75c.42-.2.73-.4.9-.6.19-.22.28-.5.28-.83 0-.3-.17-.57-.5-.8a2 2 0 00-1.17-.35c-.47 0-.86.1-1.18.31-.25.18-.64.6-1.16 1.25a.39.39 0 01-.33.17.53.53 0 01-.27-.08L3.18 3.46A.42.42 0 013 3.2c-.02-.11 0-.21.06-.3A5.55 5.55 0 018.1 0z" />
    </svg>
  );
}

SvgTickWhy.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgTickWhy.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgTickWhy svgRef={ref} {...props} />);
export default ForwardRef;
